import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import {
  IKeyValueInterface,
  WeGoAuthorizedLink,
  Permission,
  PermissionType,
  Entity
} from "./../../shared/config";
import { AddGroupVehiclePopupComponent } from "./add-groupvehicle-popup.component";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { VehicleModel } from "../../vehicle/models/vehicle.model";
import { VehicleService } from "../../vehicle/models/vehicle.service";
import { SharedVehicleGroupService } from "../models/sharedvehiclegroup.service";
import { Observable } from "rxjs/Observable";
import { Router, ActivatedRoute } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel
} from "../../shared/config";

import { Location } from "@angular/common";

@Component({
  selector: "wego-svgvehicle",
  template: require('../views/svgvehicle-list.component.html'),
  providers: [SharedVehicleGroupService, VehicleService]
})
export class SVGVehicleComponent implements OnInit {
  urlVehicleUpdate: string;
  DataListModel: DataListModel;
  vehicleList: VehicleModel[];
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  isLoading: boolean;
  message: string;
  sharedVehicleGroupHashId: string = "";
  vehicleMasterHashId: string;
  deletevehiclegroupmappingHashId: string;
  groupName: string;
  deleteMessage: string;
  isParentCheck: boolean;
  companyHashID: string = "";
  apiResponse: IAPIResponse;
  urlDefaultPage: string;
  urlSVGList: string;
  urlVehicleInfo: string;
  addSVGVehicleLink: WeGoAuthorizedLink;

  private popupMsg: string;
  private module: string;

  @ViewChild("deleteModal") public deleteModal: any;
  @ViewChild("assignGroupVehicleModal") public assignGroupVehicleModal: any;
  @ViewChild("successPopup") public successPopup: any;

  get isAnyChecked(): boolean {
    if (this.vehicleList) {
      let isCheck = this.vehicleList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.vehicleList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else this.isParentCheck = false;
      } else {
        this.isParentCheck = false;
      }

      return isCheck;
    } else {
      this.isParentCheck = false;
      return false;
    }
  }

  get isDeleteAccess(): boolean {
    if (this.vehicleList) {
      return this.vehicleList.some(x => x.isDeletable);
    } else {
      return false;
    }
  }

  constructor(
    private sharedVehicleService: SharedVehicleGroupService,
    private vehicleService: VehicleService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private locationService: Location
  ) {}

  ngOnInit() {
    this.module = this.translate.instant("LblVehicle");
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = [
      "licenceTag",
      "ownerName",
      "brand",
      "type",
      "vehicleClass",
      "color"
    ];
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlSVGList = this.authService.GetURL(ApplicationRouteURL.URL_SVG_LIST);
    this.urlVehicleInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLE_INFO
    );
    this.urlVehicleUpdate = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLE_UPDATE
    );
    this.activeRoute.params.subscribe(params => {
      let sharedVehicleGroupHashId = params["sharedVehicleGroupHashId"] || "";
      if (sharedVehicleGroupHashId != "") {
        this.sharedVehicleGroupHashId = sharedVehicleGroupHashId;

        this.GetSharedVehicleGropuDetailsByHashId();
        this.addSVGVehicleLink = new WeGoAuthorizedLink(
          "",
          Permission.PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW,
          PermissionType.INSERT,
          "btn btn-highlight navbar-right",
          "LblAddNew",
          Entity.SVG,
          this.sharedVehicleGroupHashId
        );
        this.GetGroupVehicleList();
      }
    });
  }

  public OnExport(event: any) {
    this.isLoading = true;
    // this.vehicleService.ExportVehicleList(null, this.sharedVehicleGroupHashId, this.DataListModel)
    this.vehicleService
      .ExportVehicleList(
        this.DataListModel,
        null,
        this.sharedVehicleGroupHashId
      )
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = "GroupVehicles" + new Date().toISOString() + ".csv";
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }
  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetGroupVehicleList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetGroupVehicleList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetGroupVehicleList();
  }

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetGroupVehicleList();
  }

  public OnParentCheck(isChecked: boolean) {
    this.vehicleList.forEach(x => (x.isChecked = isChecked));
  }

  public DeleteSharedVehicleGroupMapping(
    deletevehiclegroupmappingHashId: string[]
  ) {
    this.isLoading = true;
    this.sharedVehicleService
      .DeleteVehicleSVG(deletevehiclegroupmappingHashId)
      .subscribe(
        res => {
          this.apiResponse = res;
          this.DataListModel.currentPage = 1;
          this.GetGroupVehicleList();
          this.popupMsg = this.translate.instant("LblRecordRemovedSuccess", [
            this.module
          ]);
          this.ShowSuccessPopup();
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public ShowDeleteModal(): void {
    this.popupMsg = this.translate.instant(
      "LblRecordMultiplDeleteConfirmation",
      [this.module]
    );
    this.deleteModal.show();
  }

  public HideDeleteModal(): void {
    this.deletevehiclegroupmappingHashId = "";
    this.deleteModal.hide();
  }

  public SuccessModalClick(): void {
    let deletSharedVehiclegroupmappingIds: any[];
    deletSharedVehiclegroupmappingIds = this.vehicleList
      .filter(x => x.isChecked)
      .map(x => x.vehicleGroupMappingHashId);
    this.DeleteSharedVehicleGroupMapping(deletSharedVehiclegroupmappingIds);
    this.deleteModal.hide();
  }

  public GetGroupVehicleList() {
    this.isLoading = true;
    this.sharedVehicleService
      .GetSVGVehicleList(this.sharedVehicleGroupHashId, this.DataListModel)
      .subscribe(
        res => {
          this.vehicleList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }
  public GetSharedVehicleGropuDetailsByHashId() {
    this.sharedVehicleService
      .GetSharedVehicleGroupBasicDetail(this.sharedVehicleGroupHashId)
      .subscribe(
        res => {
          this.groupName = res.data.entityName;
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }
  public ShowAssignVehicleGroupModal() {
    this.assignGroupVehicleModal.sharedVehicleGroupHashId = this.sharedVehicleGroupHashId;
    this.assignGroupVehicleModal.show();
  }

  public SuccessAssignVehicleGroupModal($event: any) {
    this.GetGroupVehicleList();
    this.popupMsg = this.translate.instant("LblRecordAddedSuccess", [
      this.module
    ]); //$event.SuccessMessage;
    this.ShowSuccessPopup();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroup/components/svgvehicle-list.component.ts